import React, { type FunctionComponent } from 'react'
import { fontSize, SimpleSelect } from '@retailer-platform/shared-components'
import { Controller } from 'react-hook-form'
import { type Styles } from 'react-select'
import { type DomainMessages, useDomainMessage } from 'domains/collections/utils/domain/intl'
import { type ControllerProps } from 'utils/react-hook-form/reactHookForm.types'
import { type SelectOptionTypeIntl } from 'domains/collections/components/collections-form/utils/collectionsFormSelectOptions'
import { CollectionsFormInputWrapper } from './CollectionsFormInputWrapper'

interface CollectionsFormSelectProps extends Omit<ControllerProps, 'name'> {
  options: SelectOptionTypeIntl[]
  identifier?: string
  labelId?: DomainMessages
}

const controlStyles: Styles = {
  control: () => ({
    height: 46,
    fontSize: fontSize.X15,
    '[class*="IndicatorsContainer"]': {
      margin: 'auto',
    },
  }),
}

export const CollectionsFormSelect: FunctionComponent<CollectionsFormSelectProps> = ({
  labelId,
  identifier,
  options,
  required,
  'data-testid': testId,
  control,
}) => {
  const label = useDomainMessage(labelId)

  return (
    <CollectionsFormInputWrapper label={label}>
      <Controller
        as={SimpleSelect}
        name={identifier}
        options={options}
        placeholder={label}
        styles={controlStyles}
        control={control}
        rules={{ required }}
      />
    </CollectionsFormInputWrapper>
  )
}
